export function normalizeOption(option) {
	return {
		value: String(option.value),
		label: option.label,
		icon: option.icon,
	};
}

export function buildOptionsList(options = [], placeholderOption) {
	const list = options.map(normalizeOption);
	if (placeholderOption) {
		return [normalizeOption(placeholderOption), ...list];
	}
	return list;
}

export function resolveSelectedDisplay({
	value,
	options = [],
	placeholderOption,
	icon,
}) {
	const normalizedValue = value == null || value === "" ? "" : String(value);
	const allOptions = buildOptionsList(options, placeholderOption);
	const selected = allOptions.find((option) => option.value === normalizedValue);

	return {
		label: selected?.label ?? placeholderOption?.label ?? "",
		icon: selected?.icon ?? placeholderOption?.icon ?? icon,
	};
}
